var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4896 2.08337C6.73959 2.08337 2.08334 6.75004 2.08334 12.5C2.08334 18.25 6.73959 22.9167 12.4896 22.9167C18.25 22.9167 22.9167 18.25 22.9167 12.5C22.9167 6.75004 18.25 2.08337 12.4896 2.08337ZM12.5 20.8334C7.89584 20.8334 4.16667 17.1042 4.16667 12.5C4.16667 7.89587 7.89584 4.16671 12.5 4.16671C17.1042 4.16671 20.8333 7.89587 20.8333 12.5C20.8333 17.1042 17.1042 20.8334 12.5 20.8334Z",
    fill: "#3522B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0208 7.29163H11.4583V13.5416L16.9271 16.8229L17.7083 15.5416L13.0208 12.7604V7.29163Z",
    fill: "#3522B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access-time.351a5a00cf300c55a2b8ec27eeab2e9f.svg";
export { ForwardRef as ReactComponent };